import * as consts from '../../../constants.js';

export default {
  userSearchStatusLoad: consts.REQUEST_WITHOUT_STARTING,
  users: [],

  // Indica si se ha realizado una primera búsqueda o no.
  firstSearch: false,
};
